import { BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';
import { isBeforeDate } from 'reactApp/utils/formatDate';

const STATUS_MAP = {
    A: 'ACTIVE',
    R: 'RENEWING',
    F: 'FINISHED',
} as const;

export const getStatus = (status?: string, autorenewal?: boolean): BillingDataSubscriptionInfoStatus => {
    if (status === 'A' && typeof autorenewal === 'boolean' && !autorenewal) {
        return BillingDataSubscriptionInfoStatus.SUSPENDED;
    }

    return STATUS_MAP[status || 'A'];
};

export const getStatusByExpires = (expires?: number) => {
    if (!expires) {
        return 'A';
    }

    return isBeforeDate(expires) ? 'F' : 'A';
};
